import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import SharedScript from '@americanexpress/shared-scripts';
import { isNativeMobile } from '@americanexpress/banking-common';

const FullStoryScript = () => {
  const { fullStoryOrgId } = useSelector((state) => state.get('config').toJS());
  const isNative = useMemo(() => isNativeMobile(), []);

  if (!fullStoryOrgId || isNative || !global.BROWSER) {
    return null;
  }

  // eslint-disable-next-line no-underscore-dangle
  window._fs_org = fullStoryOrgId;

  return <SharedScript name="fullstory" windowCheck="FS" version="^1.2.1" />;
};

export default FullStoryScript;
